// ThreatWordCloud.jsx
import React, { useMemo } from "react";
import { Chart as ChartJS, Tooltip, Legend } from "chart.js";
import { WordCloudController, WordElement } from "chartjs-chart-wordcloud";
import { Chart } from "react-chartjs-2";

// Register Chart.js components
ChartJS.register(
  WordCloudController,
  WordElement,
  Tooltip,
  Legend
);

const ThreatWordCloud = ({ data }) => {
  // Transform JSON into word cloud format
  const chartData = useMemo(() => {
    const labels = Object.keys(data);
    const values = Object.values(data);

    return {
      labels,
      datasets: [
        {
          label: "Threat Term Frequency",
          data: values,
          color: "#e5e7eb", // light neutral text
          hoverColor: "#f97316", // alert orange on hover
        },
      ],
    };
  }, [data]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation:false,
    responsive:true,
    fit:true,
    padding:5,
    resizeDelay:0,
    events: [], 
    interaction: {
      mode: null
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: "#111827",
        titleColor: "#f9fafb",
        bodyColor: "#e5e7eb",
        callbacks: {
          label: (context) =>
            `Occurrences: ${context.raw}`,
        },
      },
    },
    elements: {
      word: {
        minRotation: 0,
        maxRotation: 0,
        padding: 4,
        fontFamily: "Inter, system-ui, sans-serif",
        fontWeight: "600",
      },
    },
  };

  return (
    <div className="wordCloudContainer">
      <div className="wordCloudChart">
        <Chart
          type="wordCloud"
          data={chartData}
          options={options}
        />
      </div>
    </div>
  );
};

export default ThreatWordCloud;
